// ============================================================================
// LES RÈGLES AUTOMATIQUES DE BLOCAGE — ce qui peut bloquer un magasin sans intervention.
//
// ⚠️ UNE SEULE LISTE pour la page Blocages et la fiche magasin : deux copies du même texte diraient deux règles le jour
//    où l'une bouge. La synchro périodique, elle, n'y figure pas : ses délais sont PROPRES à chaque magasin et se lisent
//    dans sa base — c'est la fiche qui l'ajoute, avec ses chiffres.
// ============================================================================

export interface AutoBlockRule { name: string; state: 'active' | 'à venir'; desc: string }

export const AUTO_BLOCK_RULES: readonly AutoBlockRule[] = [
  { name: 'Location en retard', state: 'active', desc: 'Échéance de location dépassée de plus de 2 jours calendaires (grâce comprise) → blocage automatique de la caisse. Évaluée à chaque lecture de la page Blocages.' },
  { name: 'Échéance de paiement J+10', state: 'à venir', desc: 'Sliderz Business SIGNALE l’échéance, la Console bloque (jamais le facturier). En attente du signal Sliderz Business — rien n’est simulé.' },
];
